import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ILineItemData, IPOData, IPurchaseOrder_New } from '../../po-buyer/models';
import { PoConfirmationResponseComponent } from '../components/po-confirm-delivery/po-confirmation/po-confirmation-response/po-confirmation-response.component';
import { DeliveryFollowupResponseComponent } from '../components/po-confirm-delivery/po-delivery-followup/delivery-followup-response/delivery-followup-response.component';
import { SupplierRfqUploadComponent } from '../containers/supplier-rfq-template/rfq-supplier-attachments/supplier-rfq-Upload/supplier-rfq-Upload.component';
import { IRFQTemplateDetail } from '../../pr-buyer/models';
import { SupplierRfqAcceptRejectComponent } from '../containers/supplier-rfq-template/supplier-rfq-accept-reject/supplier-rfq-accept-reject.component';

@Injectable({
  providedIn: 'root'
})
export class SupplierHelperService {

  constructor(private _modalService: BsModalService,
    private _fb : FormBuilder) { }

  public sendPODeliveryResponse(purchaseOrders : IPurchaseOrder_New[]) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Send PO Delivery Response",
        purchaseOrders
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(DeliveryFollowupResponseComponent, initialState);
    return bsModalRef.content.onClose
  }

  public sendPOConfirmationResponse(purchaseOrders : IPurchaseOrder_New[]) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Send PO Confirmation Response",
        purchaseOrders
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(PoConfirmationResponseComponent, initialState);
    return bsModalRef.content.onClose
  }

  public prepareDeliveryFollowUpFeedbackForm(purchaseOrders : IPurchaseOrder_New[]) : FormGroup {
    return this.prepareFeedbackForm(purchaseOrders);
  }

  public preparePOConfirmationFeedbackForm(purchaseOrders : IPurchaseOrder_New[]) : FormGroup {
    return this.prepareFeedbackForm(purchaseOrders);
  }

  private prepareFeedbackForm(purchaseOrders : IPurchaseOrder_New[]) : FormGroup {
    const customForm : FormGroup = this._fb.group({});
    purchaseOrders.forEach((po : IPurchaseOrder_New, index : number) => {
      const formArray : FormArray =  new FormArray([]);
      purchaseOrders[index].po_data.forEach((po_data : IPOData) => {
        const nestedForm : FormGroup =  this._fb.group({
          po_number : po_data.po_number,
          // supplier_acknowledgment_status : [(po_data.supplier_acknowledgment_status === "Yes" || po_data.supplier_acknowledgment_status === "No") ? po_data.supplier_acknowledgment_status : "", Validators.required],
          supplier_acknowledgment_status : [po_data.supplier_acknowledgment_status],
          // vendor_remarks : [po_data.vendor_remarks, [Validators.required]],
          vendor_remarks : [po_data.vendor_remarks],
          line_item_data : new FormArray([])
        });
        po_data.line_item_data.forEach((line_item_data : ILineItemData) => {
          const lineItemNestedForm : FormGroup =  this._fb.group({});
          Object.keys(line_item_data).forEach((key : string) => {
            const defaultValue = line_item_data[key as keyof ILineItemData];      
            if(key === "estimated_delivery_date") { 
              const getFormatDate = (val : any) => ('0' + val).slice(-2); // Small helper method to append 0 before date & month incase it's value is less than 10
              const date = defaultValue ? `${new Date(defaultValue).getFullYear()}-${getFormatDate(new Date(defaultValue).getMonth()+1)}-${getFormatDate(new Date(defaultValue).getDate())}` : null;
              lineItemNestedForm.addControl(key, new FormControl(date, [Validators.required]));
            } else {    
              lineItemNestedForm.addControl(key, new FormControl(defaultValue, []));
            }
          });
          lineItemNestedForm.addControl('indicator', new FormControl('Full', [Validators.required]));
          lineItemNestedForm.addControl('price', new FormControl('', []));
          lineItemNestedForm.addControl('unit_of_meassure', new FormControl('', [Validators.required]));
          lineItemNestedForm.addControl('currency', new FormControl('', [Validators.required]));
          lineItemNestedForm.addControl('confirmed_quantity', new FormControl(line_item_data.quantity, [Validators.required]));
          // lineItemNestedForm.controls['confirmed_quantity'].();

          (nestedForm.controls["line_item_data"] as FormArray).push(lineItemNestedForm)
        })
        formArray.push(nestedForm);
        console.log("formArray", formArray)
      });
      customForm.addControl(po.pr_number, formArray)
      // customForm = formArray
    });
    return customForm;
  }

  public createFeedbackRequest(formValue : Record<string | number, IPOData[]>) : { data : IPurchaseOrder_New[]} {
    const purchaseOrders : IPurchaseOrder_New[] = Object.keys(formValue).map((prNumber : any) => {
      return  {
        po_count : formValue[prNumber].length,
        pr_number : prNumber,
        po_data : formValue[prNumber]
      }
    });
    const data : { data : IPurchaseOrder_New[]} = {
      data : purchaseOrders
    }
    return data
  }

  public uploadSupplierRfQAttachment(rfqId: any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        rfqId: rfqId
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(SupplierRfqUploadComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openSupplierAcceptOrRejectQuotation(rfqTemplateDetail:IRFQTemplateDetail) {
    const initialState: ModalOptions<any> = {
      initialState: {
        rfqTemplateDetail
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(SupplierRfqAcceptRejectComponent, initialState);
    return bsModalRef.content.onClose
  }

}
